import { useUpdatePointCentralConnection } from '@/api/property-keyless/point-central/update-point-central-connection'

import { PointCentralConnectionFormValues } from './point-central.schema'

export const usePointCentralSubmit = (buildingId: number) => {
  const { mutateAsync, isPending } = useUpdatePointCentralConnection()

  const submit = (values: PointCentralConnectionFormValues) =>
    mutateAsync({ buildingId, ...values })

  return { isPending, submit }
}
